<template>
    <data-table
        action-button-text="رویداد جدید"
        action-button-icon="add"
        show-select
        remove-key="customerEventType"
        export-key="customerEventTypes"
        settings-key="customerEventTypes"
        @click:actionButton="customerEventTypeDialogRef.openDialog()"
        @getList="getList"
        @deleted="system.setSystemDefaults(true)"
        ref="dataTableRef"
        :rowClick="(item) => customerEventTypeDialogRef.openDialog(item)"
        :headers="headers"
        :items="items"
        :loading="loading"
        :totalItems="totalItems"
        :filters="filters"
        :actions="actions"
        :getAllList="getAllList"
    ></data-table>
    <customer-event-type-dialog ref="customerEventTypeDialogRef" @done="getList(dataTableRef.finalFilters)"></customer-event-type-dialog>
</template>
<script setup>
import { useApi } from '@/plugins/api';
import { useText } from '@/plugins/utilities';
import { useSystemStore } from '@/stores/system';

defineOptions({
    title: "رویدادهای مشتریان",
    validate(context) {
        return context.auth.user.full_admin && context.system.license.features.customer_event;
    },
})
const api = useApi();
const textUtil = useText();
const system = useSystemStore();
const loading = ref(false);
const customerEventTypeDialogRef = useTemplateRef('customerEventTypeDialogRef');
const dataTableRef = useTemplateRef('dataTableRef');
const items = ref([]);
const totalItems = ref(0);
const headers = ref([
    {
        title: 'عنوان',
        key: 'name',
        value: (item) => item.name,
        minWidth: 250,
    },
    {
        title: 'نحوه ثبت رویداد',
        key: 'type',
        value: (item) => item.type ? 'API' : 'دستی',
        minWidth: 180,
    },
    {
        title: 'کد اختصاصی برای API',
        key: 'shortUrl',
        value: (item) => item.type && Object.hasOwn(item, 'url') ? item.url.split('/').at(-1) : undefined,
        minWidth: 320,
        sortable: false,
    },
    {
        title: 'تعداد استفاده',
        key: 'customer_events_count',
        value: (item) => item.customer_events_count,
        minWidth: 150,
    },
]);
const filters = ref({
    page: { type: 'hidden', label: 'صفحه', value: 1 },
    perPage: { type: 'hidden', label: 'تعداد آیتم در صفحه', value: 10 },
    keyword_based: { type: 'divider', label: 'بر اساس کلمه کلیدی', value: null },
    name: { type: 'text', label: 'عنوان', value: null },
    position_based: { type: 'divider', label: 'بر اساس نحوه ثبت', value: null },
    type: { type: 'autocomplete', label: 'نحوه ثبت رویداد', items: [{ id: '1', name: 'API' }, { id: '0', name: 'دستی' }], value: [] },
})
const actions = ref([
    {
        title: 'کپی کد API',
        icon: 'content_copy',
        clicked: (selected) => textUtil.copy(selected[0].url.split('/').at(-1)),
        enabled: (selected) => selected.length === 1 && selected[0].type && Object.hasOwn(selected[0], 'url')
    },
]);
async function getList(finalFilters, cb = false) {
    loading.value = true;
    await api.customerEventTypeList(finalFilters).then(async res => {
        if (res && res.status == "OK") {
            items.value = res.data;
            totalItems.value = res.total;
        }
    }).finally(() => loading.value = false);
    if (cb)
        cb();
}
async function getAllList(finalFilters) {
    let page = 1, data = [];
    while (page) {
        await api.customerEventTypeList({
            ...finalFilters,
            perPage: 200,
            page: page,
        }).then(async res => {
            if (res && res.status == "OK") {
                data = data.concat(res.data);
                page = page == res.totalPages ? false : page + 1
            } else
                page = false;
        }).catch(() => page = false);
    }
    return data;
}
</script>
